module.exports = __webpack_public_path__ + "img/icon_time_grey.722dc8ef.svg";